import { useGetExportsQuery } from 'src/api/redux';

interface UseGetExportsParams {
  q?: string;
  sort?: string;
  order?: string;
}

/**
 * Hook to fetch exports using RTK Query with polling support
 */
const useGetExports = (params?: UseGetExportsParams) => {
  const { data, error, isLoading } = useGetExportsQuery(params, {
    pollingInterval: 60_000, // 1 minute polling
  });

  return {
    data,
    error,
    isLoading,
  };
};

export default useGetExports;
